class NoModuleSofa {
    constructor(props) {

        this.props = props
        this.sofa = props.sofa
        this.configurator = props.configurator
        this.scaleFix = 0.1
        this.offsetSizeFix = 1

    }

    makeFirstModuleAsAngle () {

        let block = false;

        this.sofa.state.forEach((item) => {
            if(item.position === 'front' && !block) {
                item.isAngle = true
                block = true
                this.sofa.configurator.$loader.removeClass('is-loading')
            }
        })
    }

    /**
     * В зависимости от позиционирования получить координаты размещения нового блока
     * @param item - новый модуль
     * @param position - текущая позиция модуля
     * */
    /*get coordinates of new block*/
    correctCoordinates(position, item) {
        let object = this.sofa;

        let angleFrontLeftObject = null

        for(let i=0; i< object.state.length; i++) {
            if (object.state[i]['position'] === 'front') {
                if(object.state[i].configurationWithAngle && object.state[i].isAngle) {
                    angleFrontLeftObject = {
                        index: i,
                        stateItem: object.state[i],
                        item: object.sections[object.state[i].id]
                    }
                }
            }
        }

        if(angleFrontLeftObject !== null) {

            if(item.position === 'frontLeft' && angleFrontLeftObject.stateItem.isAngle) {
                position.x += parseInt(angleFrontLeftObject['item'].noModuleSofaAngleFix.x)
                position.y += parseInt(angleFrontLeftObject['item'].noModuleSofaAngleFix.y)
            }
        }

        return position;
    }

    correctScale() {
        let object = this.sofa

        let fix = (object.scale + this.scaleFix)/object.scale
        this.offsetSizeFix = fix
        object.scale += this.scaleFix

        console.log('object sofa scale', object.scale)
        console.log('fix', fix)

        object.sections.forEach((item, index) => {
            item['image']['front']['append']['offsetX'] *= fix
            item['image']['front']['append']['offsetY'] *= fix
            item['image']['front']['append']['sizeX'] *= fix - ((fix-1) / 2)
            item['image']['front']['append']['sizeY'] *= fix - ((fix-1) / 2)

            item['image']['frontLeft']['append']['offsetX'] *= fix
            item['image']['frontLeft']['append']['offsetY'] *= fix
            item['image']['frontLeft']['append']['sizeX'] *= fix - ((fix-1) / 2)
            item['image']['frontLeft']['append']['sizeY'] *= fix - ((fix-1) / 2)

            item['image']['frontRight']['append']['offsetX'] *= fix
            item['image']['frontRight']['append']['offsetY'] *= fix
            item['image']['frontRight']['append']['sizeX'] *= fix - ((fix-1) / 2)
            item['image']['frontRight']['append']['sizeY'] *= fix - ((fix-1) / 2)

            item['image']['back']['append']['offsetX'] *= fix
            item['image']['back']['append']['offsetY'] *= fix
            item['image']['back']['append']['sizeX'] *= fix - ((fix-1) / 2)
            item['image']['back']['append']['sizeY'] *= fix - ((fix-1) / 2)

            item['image']['front']['prepend']['offsetX'] *= fix
            item['image']['front']['prepend']['offsetY'] *= fix
            item['image']['front']['prepend']['sizeX'] *= fix - ((fix-1) / 2)
            item['image']['front']['prepend']['sizeY'] *= fix - ((fix-1) / 2)

            item['image']['frontLeft']['prepend']['offsetX'] *= fix
            item['image']['frontLeft']['prepend']['offsetY'] *= fix
            item['image']['frontLeft']['prepend']['sizeX'] *= fix - ((fix-1) / 2)
            item['image']['frontLeft']['prepend']['sizeY'] *= fix - ((fix-1) / 2)

            item['image']['frontRight']['prepend']['offsetX'] *= fix
            item['image']['frontRight']['prepend']['offsetY'] *= fix
            item['image']['frontRight']['prepend']['sizeX'] *= fix - ((fix-1) / 2)
            item['image']['frontRight']['prepend']['sizeY'] *= fix - ((fix-1) / 2)

            item['image']['back']['prepend']['offsetX'] *= fix
            item['image']['back']['prepend']['offsetY'] *= fix
            item['image']['back']['prepend']['sizeX'] *= fix - ((fix-1) / 2)
            item['image']['back']['prepend']['sizeY'] *= fix - ((fix-1) / 2)
        })
    }
}

export default NoModuleSofa;